"use client";

import React, { useState, useEffect } from "react";
import {
  ArrowLeft,
  ArrowRight,
  Pen,
  Trash2,
  LockKeyhole,
  Info,
} from "lucide-react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { CheckboxRound } from "../../components/ui/checkboxRound";
import { useNavigate } from "react-router-dom";
import Header from "../../layouts/Header";
import { useAuth } from "../../context/AuthContext";
import logoSmall from "../../assets/images/logoSmallGrey.svg";
import infoIcon2 from "../../assets/icons/info_icon.svg";
import padlockIcon from "../../assets/icons/padlock.svg";
import { Button } from "../../components/ui/button";
import CreateSubAccount from "../../components/CreateSubAccount";
import { Separator } from "../../components/ui/separator";
import SubAccounts from "../../components/SubAccounts";
import Toaster from "../../components/ui/toaster";
export default function SettingsSubAccount() {
  const { userProfile } = useAuth();

  function TransferFunds() {
    return (
      <>
        <div className="flex justify-center mt-12 px-4 md:px-16 lg:px-32">
          <div className="max-w-3xl w-full">
            <Card className="bg-white rounded-2xl shadow-sm overflow-hidden">
              <CardHeader className="px-9 pt-6 pb-4">
                <CardTitle className="text-2xl font-semibold text-[#6D6584] text-[20px]">
                  <div className="flex items-center">
                    <div>Transfer funds</div>
                  </div>
                </CardTitle>
              </CardHeader>

              <CardContent className="px-5 pt-2  pb-6">
                <div className="grid grid-cols-2 mb-6">
                  <div className="relative w-full px-4">
                    <p className="text-[14px] text-[#6D6584] font-normal mb-2">
                      Transfer to
                    </p>
                    <input
                      type="text"
                      placeholder="Anti-phishing phrase"
                      //value={name}
                      //onChange={(e) => setCurrentPassword(e.target.value)}
                      className="border-[1px] rounded-[10px] border-[#CECBD7] text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition bg-[#FFFFFF] text-[14px] font-normal px-5 py-6"
                    />
                  </div>
                  <div className="relative w-full px-4">
                    <p className="text-[14px] text-[#6D6584] font-normal mb-2">
                      Available balance
                    </p>
                    <input
                      type="text"
                      placeholder="R 0"
                      //value={name}
                      //onChange={(e) => setCurrentPassword(e.target.value)}
                      className="rounded-[10px] bg-[#EBE9EF4D] text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition text-[14px] font-normal px-5 py-6"
                    />
                  </div>
                </div>
                <div className="columns-1 mb-6">
                  <div className="relative w-full px-4">
                    <p className="text-[14px] text-[#6D6584] font-normal mb-2">
                      Enter amount
                    </p>
                    <Button className="absolute top-[65%] transform -translate-y-1/2 right-9 bg-transparent border-[1px] border-[#EBE9EF] text-[#6D6584] text-[14px] font-semibold px-6 py-2 rounded-full hover:bg-transparent">
                      Max
                    </Button>
                    <input
                      type="text"
                      placeholder="R 0"
                      //value={name}
                      //onChange={(e) => setCurrentPassword(e.target.value)}
                      className="border-[1px] rounded-[10px] border-[#CECBD7] text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition bg-[#FFFFFF] text-[14px] font-normal px-5 py-6"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-2 mb-6">
                  <div className="relative w-full px-4">
                    <p className="text-[14px] text-[#6D6584] font-normal mb-2">
                      Transfer to
                    </p>
                    <input
                      type="text"
                      placeholder="Anti-phishing phrase"
                      //value={name}
                      //onChange={(e) => setCurrentPassword(e.target.value)}
                      className="border-[1px] rounded-[10px] border-[#CECBD7] text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition bg-[#FFFFFF] text-[14px] font-normal px-5 py-6"
                    />
                  </div>
                  <div className="relative w-full px-4">
                    <p className="text-[14px] text-[#6D6584] font-normal mb-2">
                      Available balance
                    </p>
                    <input
                      type="text"
                      placeholder="R 0"
                      //value={name}
                      //onChange={(e) => setCurrentPassword(e.target.value)}
                      className="rounded-[10px] bg-[#EBE9EF4D] text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition text-[14px] font-normal px-5 py-6"
                    />
                  </div>
                </div>
                <div className="flex justify-center py-3">
                  <Button
                    className="bg-gradient-to-r from-purple-500 to-pink-500 text-white py-2 rounded-full w-[40%]"
                    onClick={() => {
                      //setPageNo('0')
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </CardContent>
              <Separator />
              <div className="py-4 text-[14px] text-[#6D6584] font-normal">
                <div className="flex justify-center items-center">
                  <img src={padlockIcon} className="mr-1" />
                  <p>Secured by</p>
                  <img src={logoSmall} className="ml-1" />
                </div>
              </div>
            </Card>
          </div>
        </div>
      </>
    );
  }

  function ConfirmTransfer() {
    return (
      <>
        <div className="flex justify-center mt-12 px-4 md:px-16 lg:px-32">
          <div className="max-w-3xl w-full">
            <Card className="bg-white rounded-2xl shadow-sm overflow-hidden">
              <CardHeader className="px-9 pt-6 pb-4">
                <CardTitle className="text-2xl font-semibold text-[#6D6584] text-[20px]">
                  <div className="flex items-center">
                    <div>Review your deposit</div>
                  </div>
                </CardTitle>
              </CardHeader>

              <CardContent className="px-9 pt-2  pb-6">
                <div className="columns-1 mb-6">
                  <div className="relative w-full border-[1px] rounded-[12px] border-[#CECBD7] ">
                    <div className="flex justify-between border-b-[1px] border-[#CECBD7] rounded-t-[12px] w-full  focus:ring-2 focus:ring-purple-400 transition bg-[#FFFFFF] px-5 py-5">
                      <p className=" text-[14px] font-normal ">You Transfer</p>
                      <p className=" text-[14px] font-semibold text-[#423E51] ">
                        R 3 871.89{" "}
                      </p>
                    </div>
                    <div className="flex justify-between text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition bg-[#FFFFFF] text-[14px] font-normal px-5 py-5">
                      <p className=" text-[14px] font-normal ">Transfer from</p>
                      <p className=" text-[14px] font-semibold text-[#423E51] ">
                        Main Account
                      </p>
                    </div>
                    <div className="flex justify-between border-t-[1px] border-[#CECBD7] rounded-b-[12px] text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition bg-[#FFFFFF] text-[14px] font-normal px-5 py-5">
                      <p className=" text-[14px] font-normal ">Transfer to</p>
                      <p className=" text-[14px] font-semibold text-[#423E51] ">
                        Strat#1
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex justify-center py-3">
                  <Button
                    className="bg-gradient-to-r from-purple-500 to-pink-500 text-white py-2 rounded-full w-[40%]"
                    onClick={() => {
                      //setPageNo('0')
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </CardContent>
              <Separator />
              <div className="py-4 text-[14px] text-[#6D6584] font-normal">
                <div className="flex justify-center items-center">
                  <img src={padlockIcon} className="mr-1" />
                  <p>Secured by</p>
                  <img src={logoSmall} className="ml-1" />
                </div>
              </div>
            </Card>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <Toaster />
      <SubAccounts />
    </>
  );
}
